// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__tLzlQ","title":"FrontImage_title__3m3c0"};